module.exports = __webpack_public_path__ + "static/img/image82.454417d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c35/image82.png
// module id = sRic
// module chunks = 0